export default __webpack_public_path__ + "static/media/orders.87f51b30.svg";